<template>
    <!-- *********************************************
    *                 General Info                   *
    ********************************************** -->
    <text-blocks-operation-info :params="operationInfoParams" />
    <!-- *********************************************
    *                   Account Block                *
    ********************************************** -->
    <divider-generic
    dividerSize="medium"
    icon="account-balance"
    :title="t('accounts.extracts.step2.accountTitle')"/>
    <text-block-generic :params="accountTextBlockParams" :mask="ACCOUNT_NUMBER"/>
    <!-- *********************************************
    *                  Date Info Block               *
    ********************************************** -->
    <divider-generic
    dividerSize="medium"
    icon="calendar"
    :title="t('accounts.extracts.step2.dateTitle')"/>
    <!-- Begin Date -->
    <text-block-generic :params="startDateTextBlockParams"/>
    <!-- End Date -->
    <text-block-generic :params="endDateTextBlockParams"/>
    <!-- *********************************************
    *             New Extract Button Block           *
    ********************************************** -->
    <divider-generic class="last-divider" dividerSize="medium" />
    <button-primary
    :label="t('accounts.extracts.step3.newExtract')"
    buttonSize="medium"
    icon="group"
    iconPosition="right"
    @clicked="emit('newExtract')" />
</template>

<script setup>
import TextBlocksOperationInfo from '@/components/wrappers/OperationInfo'
import DividerGeneric from '@/components/generic/dividers/Generic'
import TextBlockGeneric from '@/components/generic/textBlocks/Generic'
import ButtonPrimary from '@/components/generic/buttons/Primary'

/* Assets */
import { ref } from 'vue'

/* Aux */
import { ACCOUNT_NUMBER } from '@/assets/constants/masks'
import { getDate } from '@/assets/scripts/dateBuilders'

/* Store */
import { mapGetters } from '@/store/helpers/mappers'
import { moduleMapper } from '@/store/helpers/modules.map'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Emmitters */
const emit = defineEmits(['newExtract'])

/** props received
@operationInfoParams { Object }
@extractData {Object} object with info for our current form
*/
const props = defineProps({
    operationInfoParams: Object,
    extractData: Object
})

const { getAccountsBalances } = mapGetters(moduleMapper.ACCOUNTS_EXTRACTS)

/* Data */
const accountTextBlockParams = ref({
    label: t('accounts.extracts.step2.accountLabel'),
    content: getAccountsBalances.value.find(account => account.id === props.extractData.accountId).accountNumber
})
const startDateTextBlockParams = ref({
    label: t('accounts.extracts.step2.startDateLabel'),
    content: getDate(props.extractData.beginDate),
    classes: 'capitalize'
})
const endDateTextBlockParams = ref({
    label: t('accounts.extracts.step2.endDateLabel'),
    content: getDate(props.extractData.endDate),
    classes: 'capitalize'
})
</script>

<style lang="scss" scoped>
.last-divider.apply-border {
    padding-top: unset;
}
</style>
